import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuthLayout } from "@/components/auth/AuthLayout";
import { OAuthButtons } from "@/components/auth/OAuthButtons";
import logoLight from "@/assets/logo-light.svg";
import logoDark from "@/assets/logo-dark.svg";

export default function RegisterPage() {
  const { t } = useTranslation("auth");

  return (
    <AuthLayout>
      {/* Logo row */}
      <div className="flex items-center gap-2.5 mb-8">
        <img
          src={logoLight}
          alt="WiServices"
          className="h-[26px] block dark:hidden"
        />
        <img
          src={logoDark}
          alt="WiServices"
          className="h-[26px] hidden dark:block"
        />
        <span className="ml-auto inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border border-hairline bg-panel text-muted-foreground font-mono">
          Console
        </span>
      </div>

      {/* Heading */}
      <h2 className="text-2xl font-medium tracking-tight mb-2 text-ink">
        {t("register.title")}
      </h2>
      <p className="text-sm text-muted-foreground mb-7">
        {t("register.subtitle")}
      </p>

      {/* OAuth Buttons */}
      <OAuthButtons isSignUp />

      {/* Sign In Link */}
      <p className="mt-6 text-center text-xs text-muted-foreground">
        {t("register.hasAccount")}{" "}
        <Link to="/login" className="text-brand hover:underline">
          {t("register.signIn")}
        </Link>
      </p>
    </AuthLayout>
  );
}
